define('modules/customer-logo-upload',['jquery', 'server-settings', 'modules/overlay-box'], function ($, serverSettings, OverlayBox) {
  return (function () {
    function CustomerLogoUpload($trigger, onUpload, onError) {
      this.onUpload = onUpload;
      this.onError = onError;
      this.trigger = $trigger;
      this.initBindings();
    }

    CustomerLogoUpload.prototype.setupOb = function () {
      var ob = new OverlayBox($('#popupLogoUploadTemplate'), {});
      ob.setup();
      ob.load(function () {
        ob.show();
      });

      this.ob = ob;
    };

    CustomerLogoUpload.prototype.initBindings = function () {
      var _this = this;

      $(document).on('click', '#popupBtnLogoUploadAbort', function (event) {
        event.preventDefault();
        _this.ob.destroy();
      });

      $(document).on('click', '#popupLogoUploadFile', function (e) {
        this.value = null;
      });

      $(document).on('click', '#popupBtnLogoUpload', function (event) {
        event.preventDefault();
        var fr = new FileReader();

        if (!_this.uploadingfile && _this.selectedfile) {
          _this.uploadingFile = true;
          $(this).attr('data-disabled', 'disabled');

          fr.onload = function (e) {
            var name = $('#popupLogoUploadName').val();

            $.ajax({
              method: 'POST',
              url: serverSettings.customerLogoApi,
              data: { ImageData: e.target.result, Name: name, OriginalName: _this.selectedfile.name }
            })
              .success(_this.onUpload)
              .fail(_this.onError)
              .always(function () {
                _this.ob.destroy();
                _this.uploadingfile = false;
                _this.selectedfile = null;
              });
          };

          fr.readAsDataURL(_this.selectedfile);
        }
      });

      $(document).on('change', '#popupLogoUploadFile', function (e) {
        _this.selectedfile = e.target.files[0];
        var name = _this.selectedfile.name;
        var index = name.lastIndexOf('.');
        if (index > -1) {
          name = name.substring(0, index);
        }
        $('#popupLogoUploadName').val(name.substring(name.i));
      });

      this.trigger.on('click', function (event) {
        _this.setupOb();
      });
    };

    return CustomerLogoUpload;
  })();
});

